<template>
    <div class="step1">
      <h2>基金从业人员资格考试</h2>
      <div class="con">
        <h3>考生登录</h3>
        <p><input type="checkbox" v-model="isChecked">已按要求关闭电子设备，并上交指定位置</p>
        <ul>
          <li><input type="text" class="ipt1" placeholder="请输入您的准考证号(任意数字)" v-model="zkzID"></li>
          <li><a href="javascript:void(0)" class="a1" @click="goNext">登 录</a></li>
        </ul>
      </div>
    </div>
</template>
<script>
  import { mapGetters } from 'vuex'

  import { setPageTitle, isEmptyObject, parseNumber } from "@/utils"
  export default {
    name: 'Step1',
    components: {},
    computed: {
      ...mapGetters([
          'siteData'
      ])
    },
    data() {
      return {
        courseName: '',
        siteCourseID: '',
        courseID: '',
        zkzID: '',
        isChecked:false
      }
    },
    async mounted() {
      const { flag } = this.$route.params
      let _flag = flag === 'paidExam' ? '' : flag
      const { courseID, siteCourseID } = this.$route.query
      const { majorID } = this.$categoryInfo
      this.courseID = courseID
      this.siteCourseID = parseNumber(siteCourseID)

      if (isEmptyObject(this.siteData)) {
        let params = {
          flag: _flag,
          majorID: majorID,
          siteCourseID: this.siteCourseID
        }
        await this.$store.dispatch('getCurrentSiteInfo', params)
          .then(res => {
          const { siteCourseName } = res.currentCourse
          this.courseName = siteCourseName
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
      } else {
        this.courseName = this.siteData.currentCourse.siteCourseName
      }
      document.title = setPageTitle(this.courseName)
    },
    methods: {
      goNext() {
        let checkNumber = this.zkzID.trim()
        let reg = /[\u4E00-\u9FA5]/g
        if (reg.test(checkNumber)) {
            alert("请输入数字！")
            return
        }
        if (checkNumber == null || checkNumber == "") {
            alert("准考证号不能为空，请输入！");
        } else if(!this.isChecked){
            alert('请勾选复选框') //提示语
        }else if (parseInt(checkNumber)) {
          const { flag } = this.$route.query
          if (flag === 'ordinary') {
            this.$router.push({
              path: 'step2',
              query: {
                ...this.$route.query,
                zkzID: this.zkzID
              },
            })
            
          } else {
            this.$router.push({
              path: 'step2',
              query: {
                siteCourseID: this.siteCourseID,
                courseID: this.courseID,
                zkzID: this.zkzID
              }
            })
          }
        } else {
            alert('准考证号的错误!')
        }
      }
    }

  }
</script>
<style lang="scss" scoped>
  $bgUrl: '../../assets/images';
  .step1{
    background:#f8f8f8;
    height:600px;
    h2{
      font-size:48px;
      line-height:60px;
      text-align:center;
      color:#1d75cf;
      padding:60px 0;
      letter-spacing:10px;
    }
    .con{
      padding:20px 0 50px 330px;
      h3{
        line-height:32px;
        font-size:20px;
        color:#1d75cf;
      }
      p{
        line-height:32px;
        font-size:14px;
        color:#666;
        padding:15px 0;
        input{
          vertical-align:-2px;
          *vertical-align:2px;
          margin-right:5px;

        }

      }
      li{
        margin-bottom:20px;
        overflow:hidden;
        input{
          width:330px;
          height:38px;
          line-height:38px;
          text-indent:10px;
          font-size:14px;
          color: #999;
          background:#e4e4e4;
          border:none;
        }
      }
      .a1{
        display:inline-block;
        width:340px;
        height:38px;
        line-height:38px;
        text-align:center;
        font-size:18px;
        color:#fff;
        background:#1d75cf;
        border-radius:3px;
        text-decoration:none;
        &:hover{ background:#1465b9;}
      }

    }
  }

</style>
